var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransferTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.75L6.79289 9.45711L7.5 10.1642L8.20711 9.45711L7.5 8.75ZM8.5 3.125C8.5 2.57272 8.05228 2.125 7.5 2.125C6.94772 2.125 6.5 2.57272 6.5 3.125L8.5 3.125ZM3.66789 6.33211L6.79289 9.45711L8.20711 8.04289L5.08211 4.91789L3.66789 6.33211ZM8.20711 9.45711L11.3321 6.33211L9.91789 4.91789L6.79289 8.04289L8.20711 9.45711ZM8.5 8.75L8.5 3.125L6.5 3.125L6.5 8.75L8.5 8.75Z",
    fill: "#E5C48F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10L3.125 10.625C3.125 11.3154 3.68464 11.875 4.375 11.875L10.625 11.875C11.3154 11.875 11.875 11.3154 11.875 10.625V10",
    stroke: "#E5C48F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransferTo);
export default __webpack_public_path__ + "static/media/icon-transfer-to.d97691443d45c2032540c25f2ca0fb70.svg";
export { ForwardRef as ReactComponent };